export default __webpack_public_path__ + "static/media/logo-blockfon.51ef4a01.svg";